<template>
  <!-- 点击更换封面弹窗 -->
  <el-dialog
    :visible.sync="modelValue"
    width="400px"
    center
    custom-class="relic-upload-choose"
  >
    <div class="choose-title font-h3">修改建筑封面</div>
    <div class="choose-btn font-h3">
      <file-uploader-vue @onFileChange="handleUploadCoverImg">
        <div class="choose-btn-photo">从本地选择</div>
      </file-uploader-vue>
      <div class="choose-btn-photo" @click="handleInPhoto">从相册选择</div>
    </div>
    <div class="choose-cancel" @click="modelValue = false">取消</div>
    <relic-upload-choose-photo-vue
      v-model="showInner"
      :photoAlbum="photoAlbum"
      v-if="photoAlbum[0]"
      @onCancelPhotoCover="handleCancelPhotoCover"
      @onPhotoAlbumSuccessCover="handlePhotoAlbumSuccessCover"
    />
    <relic-upload-cropper-vue
      :imgUrl="coverImgUrl"
      v-model="showLocalCropper"
      @onLocalUpdateCover="handleLocalUpdateCover"
      @onCancelUpdateCover="handleCancelUpdateCover"
    />
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { getRelicPhoto } from '../../../api/index';
import { modelMixin } from '../../../assets/js/mixins/model';
import fileUploaderVue from '../../layout/file-uploader.vue';
import relicUploadChoosePhotoVue from './relic-upload-choose-photo.vue';
import relicUploadCropperVue from './relic-upload-cropper.vue';
export default {
  name: 'RelicUploadChoose',
  mixins: [modelMixin],
  components: {
    relicUploadChoosePhotoVue,
    relicUploadCropperVue,
    fileUploaderVue
  },
  computed: {
    ...mapGetters('relic', ['gettersRelicDetail'])
  },
  data() {
    return {
      showInner: false,
      coverImgUrl: '',
      showLocalCropper: false,
      photoAlbum: []
    };
  },
  methods: {
    /**
     * 进入相册回调
     */
    handleInPhoto() {
      getRelicPhoto({
        relicAutoIncrementId: this.gettersRelicDetail.relicAutoIncrementId,
        doPaging: false
      }).then(res => {
        if (res.data.code == 200) {
          this.photoAlbum = res.data.data.items;
          if (this.photoAlbum.length > 0) {
            this.showInner = true;
          } else {
            this.$prompt('相册暂无图片');
          }
        }
      });
      // this.showInner = true;
    },
    /**
     * 上传图片点击回调
     */
    handleUploadCoverImg({ files }) {
      let file = files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        this.coverImgUrl = reader.result;
        //
        this.showLocalCropper = true;
      };
    },
    /**
     * 本地上传封面成功回调
     */
    handleLocalUpdateCover() {
      this.modelValue = false;
      this.$emit('onLocalUpdateCover');
    },
    /**
     * 从本地取消更新图片回调
     */
    handleCancelUpdateCover() {
      this.modelValue = false;
    },
    /**
     * 从图库取消更新图片回调
     */
    handleCancelPhotoCover() {
      this.modelValue = false;
    },
    /**
     * 从图库上传成功
     */
    handlePhotoAlbumSuccessCover() {
      this.$emit('onUpdateFromPhotoAlbum');
      this.modelValue = false;
    }
  }
};
</script>

<style lang="scss">
.relic-upload-choose {
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 28px 24px;
      overflow-y: auto;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .choose-title {
    padding-bottom: 15px;
    font-size: 16px;
    border-bottom: 1px solid $color-border-light;
  }
  .choose-btn {
    display: flex;
    justify-content: space-around;
    margin-top: 45px;
    &-photo {
      width: 116px;
      height: 45px;
      border: 1px solid $color-primary-light;
      color: $color-primary;
      font-size: 15px;
      line-height: 45px;
      text-align: center;
      cursor: pointer;
    }
  }
  .choose-cancel {
    margin-top: 50px;
    padding: 5px 0;
    text-align: center;
    cursor: pointer;
    width: 54px;
    margin-left: 300px;
    border-bottom: 1px solid $color-disabled;
  }
}
</style>
